import { To } from "@remix-run/router"
import { useCallback, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { NavigateOptions } from "react-router/dist/lib/context"

import { appStore } from "../store/AppStore"

export const useSmoothNavigate = () => {
  const setSpinner = appStore((state) => state.setSpinner)
  const navigateDom = useNavigate()
  // react router cannot pass params to back nav, hence done manually
  const setLastRouteIsBackNav = appStore((state) => state.setLastRouteIsBackNav)
  const guard = useRef(false)

  return useCallback(
    (to: To | number, options: NavigateOptions = {}) => {
      if (guard.current && to !== -1) return
      guard.current = true
      setSpinner("in")
      setTimeout(() => {
        if (typeof to === "number") {
          setLastRouteIsBackNav(true)
          navigateDom(to)
        } else {
          setLastRouteIsBackNav(false)
          navigateDom(to, { ...options })
        }
      }, 10)
      setTimeout(() => (guard.current = false), 1000)
    },
    [navigateDom, setSpinner],
  )
}
